import React from "react";

import cx from "@hsl/core/utils/cx";

export interface Props {
    type: "light" | "dark";
    size?: "small" | "large";
    text: string;
}

const Tag = ({ text, type, size }: Props) => {
    if (!text || text === "-") return null;
    return (
        <div
            className={cx(
                {
                    "bg-pastel-blue text-dark-blue": type === "light",
                    "bg-dark-blue text-white": type === "dark",
                    "px-2 text-xs": size === "small",
                    "px-3 text-base": size === "large",
                },
                "inline-flex h-max whitespace-nowrap rounded-sm py-1 capitalize",
            )}
        >
            {text}
        </div>
    );
};

export default Tag;
